<template>
  <div class="container text-left font-weight-bold">
    <el-card class="mt-3 p-3">
      <span>{{ $t('general.reset_password_message') }}</span>
      <el-input v-model="password" type="password" :placeholder="$t('placeholder.enter_new_password')" />
      <password v-model="password" strength-meter-only />
      <el-input
        v-model="passwordConfirm"
        type="password"
        class="mt-2"
        :placeholder="$t('placeholder.confirm_new_password')"
      />
      <el-button class="mt-2 float-right" type="primary" @click="onSubmit">
        {{ $t('general.submit') }}
      </el-button>
    </el-card>
  </div>
</template>

<script>
import Password from 'vue-password-strength-meter';

export default {
  name: 'PasswordResetView',
  components: { Password },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      password: '',
      passwordConfirm: '',
      minCount: 8,
    };
  },
  computed: {
    hash() {
      return this.$route.params.hash;
    },
  },
  methods: {
    async onSubmit() {
      if (this.password.length < this.minCount) {
        this.$message.error(this.$t('messages.password_at_least_digits', { count: this.minCount }));
        return;
      }

      if (this.password !== this.passwordConfirm) {
        this.$message.error(this.$t('messages.password_not_same'));
        return;
      }
      try {
        let result = await this.$parse.Cloud.run('resetPassword', { hash: this.hash, password: this.password }, {});
        this.$message.info(this.$t(result.message));
        this.$router.replace({ name: this.$routeNames.LOGIN_PAGE_ROUTE });
      } catch (e) {
        this.$message.error(this.$t(e.message));
        this.password = '';
        this.passwordConfirm = '';
      }
    },
  },
};
</script>

<style scoped></style>
